<template>
  <div class="s-component">
    <slot>
    </slot>
    <SVersionModalTip ref="SVersionModalTip"/>
    <SVersionDialogTip ref="SVersionDialogTip"/>
    <SVersionModalAddress ref="SVersionModalAddress"/>
    <SVersionModalInviteTeam ref="SVersionModalInviteTeam" @inviteSuccess="init"/>
  </div>
</template>

<script>
import SVersionModalTip from './_components/VersionModalTip.vue'
import SVersionDialogTip from './_components/VersionDialogTip.vue'
import SVersionModalAddress from './_components/VersionModalAddress.vue'
import SVersionModalInviteTeam from './_components/VersionModalInviteTeam.vue'

export default {
  name: 'SVersionWrap',
  components: {
    SVersionModalAddress,
    SVersionModalInviteTeam,
    SVersionModalTip,
    SVersionDialogTip
  },
  props: {
    coinStr: {
      type: String,
      default: ''
    },
    apiList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // ===== btn =====
    btnNoBegin: {
      type: Object,
      default: () => {
        return {}
      }
    },
    btnNoFix: {
      type: Object,
      default: () => {
        return {}
      }
    },
    btnReceive: {
      type: Object,
      default: () => {
        return {}
      }
    },
    btnAlreadyReceive: {
      type: Object,
      default: () => {
        return {}
      }
    },
    btnExpire: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // ===== modal =====
    modalBg: {
      type: Object,
      default: () => {}
    },
    modalCloseIcon: {
      type: Object,
      default: () => {}
    },
    modalTitleStyle: {
      type: String,
      default: '{}'
    },
    modalTextStyle: {
      type: String,
      default: '{}'
    },
    modalConfirmBtnStyle: {
      type: String,
      default: '{}'
    },
    modalCancelBtnStyle: {
      type: String,
      default: '{}'
    }
  },
  inject: {
    eventBus: {
      default: null
    }
  },
  provide () {
    return {
      $MainWrap: this
    }
  },
  data () {
    return {
      homeInfo: {},
      wdFrom: '',
      from: '',
      // 存储所有API请求返回的数据
      apiData: {}
    }
  },
  computed: {
    requestAPI() {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    },
    // 合并实例数据和API数据，供子组件使用
    combinedData() {
      return {
        ...this.$data,
        ...this.apiData
      }
    }
  },
  async mounted() {
    const { from, wdFrom } = this.$route.query
    this.from = from
    this.wdFrom = wdFrom
    if (this.eventBus) {
      // 登录成功操作添加
      this.eventBus.on('loginSuccess', () => {
        window.location.reload()
      })
      // 登出操作添加
      this.eventBus.on('signOut', () => {
        window.location.reload()
      })
    }
    // eslint-disable-next-line no-undef
    window.$checkLogin && window.$checkLogin()
    await this.init()
  },
  methods: {
    // 获取首页信息
    init() {
      if (this.apiList.length > 0) {
        const token = localStorage.getItem('activeToken')
        this.apiList.forEach(item => {
          if (item.isLogin && item.isLogin.trim() === '1' && !token) {
            console.log(item.api + '> 需要登录')
            return
          }
          const params = {}
          if (item.a_id) {
            params.a_id = item.a_id
          }
          this.requestAPI({
            url: item.api,
            method: 'get',
            params: params
          }).then((res) => {
            if (res) {
              // 将数据存储到 apiData 对象中，确保响应式
              this.$set(this.apiData, item.key, res)
              // 为了向下兼容，同时在实例上设置属性（如果是已知属性）
              if (Object.prototype.hasOwnProperty.call(this, item.key)) {
                this[item.key] = res
              }
            }
          }).catch((err) => {
            this.$message.error(err.msg || '系统错误')
          })
        })
      }
    },
    // 重置
    reset() {
      this.init()
    },
    // 打开公共弹窗
    openVersionModalTip (options) {
      this.$refs.SVersionModalTip.open(options)
    },
    // 打开确认提示弹窗
    openVersionDialogTip (options) {
      this.$refs.SVersionDialogTip.open(options)
    },
    myAlert(options) {
      const { str, title = '提示', showCancel = '', sb, eb, fb } = options
      this.$alert(str, title, {
        customClass: 'my_alert',
        confirmButtonText: '确定',
        cancelButtonClass: showCancel,
        showCancelButton: showCancel,
        callback: action => {
          if (action === 'confirm') {
            sb && sb()
          } else {
            eb && eb()
          }
          fb && fb()
        }
      })
    },
    // 打开领取成功的弹窗
    openVersionDialogTipSuccess (materials) {
      if (materials.length <= 0) {
        return
      }
      let content = ''
      materials.forEach((item, index) => {
        if (index === materials.length - 1) {
          content = content + item.name + '*' + item.amount
        } else {
          content = content + item.name + '*' + item.amount + '+'
        }
      })
      this.$refs.SVersionDialogTip.open({
        title: '提示',
        content: '恭喜您获得' + ' ' + content,
        btnConfirmText: '确定',
        btnCancelText: '',
        onConfirm: () => {},
        onCancel: () => {}
      })
      this.init();
    },
    // 打开地址
    openAddress (activityId) {
      this.$refs.SVersionModalAddress.open(activityId)
    }
  }
}
</script>
<style lang="scss" scoped>
.s-component {
  position: relative;
  width: 1920px;
  user-select: none;
}
</style>
